<template>
  <Teleport v-if="mounted" to="#header-breadcrumbs">
    <CBreadcrumb v-bind="{ routes }" />
  </Teleport>
  <CPageHeader
    title="add_bot"
    :key="acceptConfig"
    :accept-btn="acceptConfig"
    @on-cancel="
      $router.push({
        name: 'Bots',
      })
    "
    @on-create="submit"
  />
  <CCard class="mt-6 p-5 grid lg:grid-cols-[1fr_1px_1fr] gap-2 lg:gap-5">
    <div class="flex flex-col gap-4">
      <FGroup :label="$t('heading')">
        <FInput
          class="!h-10 lg:!h-12"
          autocomplete="off"
          :placeholder="$t('enter_heading')"
          v-model="formBot.values.name"
          :error="formBot.$v.value.name?.$error"
        />
      </FGroup>
      <FGroup :label="$t('exchanges')">
        <div class="flex-y-center gap-2 w-full">
          <FSelect
            :options="exchanges"
            v-model="formBot.values.exchange"
            :error="formBot.$v.value.exchange?.$error"
            :placeholder="$t('choose_exchange')"
            label-key="title"
            value-key="id"
            class="w-full"
          />

          <CButton
            variant="secondary"
            class="!w-10 !h-10 !rounded-full flex-center !text-[#535E69]"
            icon="icon-add !text-2xl"
            text=""
            @click="addModal = true"
          />
        </div>
      </FGroup>
      <FGroup :label="$t('strategy')">
        <FSelect
          :options="strategies"
          v-model="formBot.values.strategy"
          :error="formBot.$v.value.strategy?.$error"
          label-key="title"
          value-key="id"
          :placeholder="$t('choose_strategy')"
        />
      </FGroup>
    </div>
    <div class="w-px h-[calc(100%-28px)] mt-auto bg-gray-100" />
    <div class="flex flex-col gap-4">
      <FGroup :label="t('coin_assigned', { count: 'USDT' })">
        <template #labelOpposite v-if="isDesktop">
          <p class="text-xs text-gray mr-auto ml-1">
            ({{ $t("tradable_balance") }})
          </p>
          <div class="flex-y-center gap-16">
            <span class="text-dark-100 text-sm font-normal">
              {{ $t("available_bot_balance") }}
            </span>
            <span
              class="pr-10 text-dark-100 text-sm font-normal"
              :class="{ 'pr-[88px]': formBot.values.exchange }"
            >
              {{ $t("total_bot_balance") }}
            </span>
          </div>
        </template>
        <div class="flex-y-center gap-2 w-full">
          <FInput
            autocomplete="off"
            placeholder="10 000"
            v-maska="moneyMask"
            :error="formBot.$v.value.money?.$error || isCheck || isLowMoney"
            v-model="formBot.values.money"
            class="!pr-0 !h-10 lg:!h-12"
            suffix-class="pr-1"
            @focus="handleInputFocus"
          >
            <template #suffix v-if="isDesktop">
              <div v-if="checkExchangeBalance?.length" :key="isRefreshed">
                <div class="flex-y-center ml-2">
                  <div
                    v-for="balance in checkExchangeBalance"
                    :key="balance?.id"
                    class="flex-center min-w-[120px] px-3 w-fit h-10 bg-[#EEEFF3] border-r border-gray-50"
                  >
                    <p
                      v-if="checkExchangeBalance?.length"
                      class="text-sm leading-130 text-dark-100"
                      :class="{ 'refreshed-animation': !isRefreshed }"
                    >
                      {{
                        (Number(balance?.available_usdt_balance) ?? 0)?.toFixed(
                          3,
                        )
                      }}
                    </p>
                    <p v-else class="text-sm leading-130 text-dark-100">0,00</p>
                  </div>
                  <div
                    v-for="balance in checkExchangeBalance"
                    :key="balance?.id"
                    class="flex-center min-w-[120px] px-3 w-fit h-10 bg-[#EEEFF3]"
                  >
                    <p
                      v-if="checkExchangeBalance?.length"
                      :class="{ 'refreshed-animation': !isRefreshed }"
                      class="text-sm leading-130 text-dark-100 transition-200"
                    >
                      {{ (Number(balance?.usdt_balance) ?? 0)?.toFixed(3) }}
                    </p>
                    <p v-else class="text-sm leading-130 text-dark-100">0,00</p>
                  </div>
                </div>
              </div>
              <div v-else class="flex-y-center rounded-lg overflow-hidden">
                <div
                  class="flex-center min-w-[120px] px-3 w-fit h-10 bg-[#EEEFF3] border-r border-gray-50"
                >
                  <p class="text-sm leading-130 text-dark-100">0,00</p>
                </div>
                <div
                  class="flex-center min-w-[120px] px-3 w-fit h-10 bg-[#EEEFF3]"
                >
                  <p class="text-sm leading-130 text-dark-100">0,00</p>
                </div>
              </div>
            </template>
          </FInput>
          <Transition name="fade" mode="in-out">
            <CButton
              v-if="formBot.values.exchange"
              variant="secondary"
              class="!w-10 !h-10 !rounded-full flex-center !text-[#535E69]"
              icon="icon-refresh !text-lg"
              :main-class="['flex relative', isRefreshed ? 'refresh' : '']"
              text=""
              @click="refreshBalance"
            />
          </Transition>
        </div>
        <div class="w-full" v-if="isMobile">
          <div class="w-full flex-y-center">
            <span class="w-full text-center text-dark-100 text-sm font-normal">
              {{ $t("available_bot_balance") }}
            </span>
            <span class="w-full text-center text-dark-100 text-sm font-normal">
              {{ $t("total_bot_balance") }}
            </span>
          </div>
          <div class="w-full rounded-lg overflow-hidden">
            <div
              v-if="checkExchangeBalance?.length"
              :key="isRefreshed"
              class="w-full"
            >
              <div class="flex-y-center ml-2">
                <div
                  v-for="balance in checkExchangeBalance"
                  :key="balance?.id"
                  class="w-full flex-center min-w-[120px] px-3 h-10 bg-[#EEEFF3] border-r border-gray-50"
                >
                  <p
                    v-if="checkExchangeBalance?.length"
                    class="text-sm leading-130 text-dark-100"
                    :class="{ 'refreshed-animation': !isRefreshed }"
                  >
                    {{
                      (Number(balance?.available_usdt_balance) ?? 0)?.toFixed(3)
                    }}
                  </p>
                  <p v-else class="text-sm leading-130 text-dark-100">0,00</p>
                </div>
                <div
                  v-for="balance in checkExchangeBalance"
                  :key="balance?.id"
                  class="w-full flex-center min-w-[120px] px-3 h-10 bg-[#EEEFF3]"
                >
                  <p
                    v-if="checkExchangeBalance?.length"
                    :class="{ 'refreshed-animation': !isRefreshed }"
                    class="text-sm leading-130 text-dark-100 transition-200"
                  >
                    {{ (Number(balance?.usdt_balance) ?? 0)?.toFixed(3) }}
                  </p>
                  <p v-else class="text-sm leading-130 text-dark-100">0,00</p>
                </div>
              </div>
            </div>
            <div v-else class="w-full flex-y-center">
              <div
                class="w-full flex-center min-w-[120px] px-3 h-10 bg-[#EEEFF3] border-r border-gray-50"
              >
                <p class="text-sm leading-130 text-dark-100">0,00</p>
              </div>
              <div
                class="w-full flex-center min-w-[120px] px-3 h-10 bg-[#EEEFF3]"
              >
                <p class="text-sm leading-130 text-dark-100">0,00</p>
              </div>
            </div>
          </div>
        </div>
      </FGroup>
      <FGroup :label="$t('work_time')" wrapper-class="!justify-start">
        <template #labelOpposite>
          <p class="text-xs text-gray ml-1">{{ $t("in_hours") }}</p>
        </template>
        <FInput
          autocomplete="off"
          disabled
          class="!h-10 lg:!h-12"
          :placeholder="$t('work_time')"
          v-model="formBot.values.hours"
        />
      </FGroup>
      <FGroup :label="$t('map_open_position')" wrapper-class="!justify-start">
        <FInput
          autocomplete="off"
          disabled
          class="!h-10 lg:!h-12"
          :placeholder="$t('map_open_position')"
          v-model="max_open_position"
        />
      </FGroup>
    </div>
  </CCard>
  <CCard class="p-5 mt-5">
    <div class="flex-center-between">
      <p class="text-xl leaidng-130 font-semibold text-dark-100">
        {{ $t("coins") }}
      </p>
      <div class="flex-y-center gap-4">
        <p class="text-base text-dark-100">{{ $t("choose_all") }}</p>
        <FToggle v-model="chooseAll" :disabled="isStrategyCoins" />
      </div>
    </div>
    <div class="mt-4 gap-7">
      <CCoinsSelect
        :disabled="isStrategyCoins"
        :default-options="chosenCoins?.map((el) => el?.id)"
        @choose-option="chosenCoins.push($event)"
        @remove-option="removeCoin"
        :error="coinError"
      />
    </div>

    <div class="flex-y-center flex-wrap gap-3 mt-4">
      <TransitionGroup name="from-right">
        <div
          v-for="coin in chosenCoins"
          :key="coin?.id"
          class="flex-y-center gap-2 p-1.5 pr-3 bg-gray-800 rounded-lg"
        >
          <CAvatar :image="coin?.image_url" class="!w-7 !h-7" />
          <p class="text-sm leading-130 text-dark-100 font-medium">
            {{ coin?.title }}
          </p>
          <svg
            v-if="!isStrategyCoins"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="group cursor-pointer"
            @click="removeCoin(coin)"
          >
            <path
              opacity="0.4"
              d="M9.99935 18.3334C14.6017 18.3334 18.3327 14.6024 18.3327 10C18.3327 5.39765 14.6017 1.66669 9.99935 1.66669C5.39698 1.66669 1.66602 5.39765 1.66602 10C1.66602 14.6024 5.39698 18.3334 9.99935 18.3334Z"
              fill="#8898AA"
            />
            <path
              d="M10.8841 9.99999L12.8008 8.08332C13.0424 7.84165 13.0424 7.44165 12.8008 7.19999C12.5591 6.95832 12.1591 6.95832 11.9174 7.19999L10.0008 9.11665L8.08411 7.19999C7.84245 6.95832 7.44245 6.95832 7.20078 7.19999C6.95911 7.44165 6.95911 7.84165 7.20078 8.08332L9.11745 9.99999L7.20078 11.9167C6.95911 12.1583 6.95911 12.5583 7.20078 12.8C7.32578 12.925 7.48411 12.9833 7.64245 12.9833C7.80078 12.9833 7.95911 12.925 8.08411 12.8L10.0008 10.8833L11.9174 12.8C12.0424 12.925 12.2008 12.9833 12.3591 12.9833C12.5174 12.9833 12.6758 12.925 12.8008 12.8C13.0424 12.5583 13.0424 12.1583 12.8008 11.9167L10.8841 9.99999Z"
              fill="#8898AA"
              class="group-hover:fill-red transition-300"
            />
          </svg>
        </div>
      </TransitionGroup>
    </div>
  </CCard>
  <CExchangeForm
    :show="addModal"
    title="add_exchange"
    v-bind="{ form }"
    :loading="addLoading"
    @close="closeModal"
    @submit="addExchange"
  />
</template>

<script setup lang="ts">
import { useMounted } from "@/composables/useMounted";
import { useI18n } from "vue-i18n";
import { computed, ref, watch, onMounted } from "vue";
import CBreadcrumb from "@/components/Common/CBreadcrumb.vue";
import CPageHeader from "@/components/CPageHeader.vue";
import CCard from "@/components/Card/CardWrapper.vue";
import FGroup from "@/components/Form/FGroup.vue";
import FInput from "@/components/Form/Input/FInput.vue";
import FSelect from "@/components/Form/Select/FSelect.vue";
import CButton from "@/components/Common/CButton.vue";
import FToggle from "@/components/Form/FToggle.vue";
import CCoinsSelect from "@/modules/Bots/components/CCoinsSelect.vue";
import CAvatar from "@/components/CAvatar.vue";
import CExchangeForm from "@/modules/Exchanges/components/Dialog/CExchangeForm.vue";
import { useForm } from "@/composables/useForm";
import { required } from "@vuelidate/validators";
import ApiService from "@/services/ApiService";
import { reactive } from "@vue/runtime-core";
import { useRouter } from "vue-router";
import { moneyMask } from "@/utils";
import { useCustomToast } from "@/composables/useCustomToast";
import { useAuthStore } from "@/modules/Auth/stores";
import { debounce } from "@/utils";
import { useMobile } from "@/composables/useMobile";
import { trackCustomEvent } from "@/utils/fbq";

import { usePushToDataLayer } from "@/composables/usePushToDataLayer";
const { pushToDataLayer } = usePushToDataLayer();

const { mounted } = useMounted();
const { t } = useI18n();
const { showToast } = useCustomToast();
const router = useRouter();

const { isMobile } = useMobile("mobile");
const { isDesktop } = useMobile("desktop");

const chosenCoins = ref<any>([]);
const chooseAll = ref(false);
const coins = ref<any[]>([]);
const exchanges = ref<any[]>([]);
const strategies = ref<any[]>([]);
const coinError = ref(false);

const isStrategyCoins = ref(false);
const max_open_position = ref(0);
const available_usdt_Balance = ref(0);

const isCheck = ref(false);
const isLowMoney = ref(false);

const form = useForm(
  {
    title: "",
    exchange: "",
    api_key: "",
    secret_key: "",
  },
  {
    title: { required },
    exchange: { required },
    api_key: { required },
    secret_key: { required },
  },
);

const minAndMaxValue = computed(() => ({
  money: {
    required,
    // minValue: () => minValue(this.max_open_position.value * 15),
    // maxValue: () => maxValue(this.available_usdt_Balance.value),
  },
}));
const formBot = useForm(
  {
    name: "",
    exchange: "",
    strategy: "",
    currency: "",
    hours: "",
    money: "",
  },
  {
    name: { required },
    exchange: { required },
    strategy: { required },
    ...minAndMaxValue.value,
  },
);

const addModal = ref(false);
const isRefreshed = ref(false);
const user = computed(() => useAuthStore().user);
if (user.value?.user_bots_count === user.value?.plan?.bots_count) {
  router.push({ name: "Bots" });
}
const closeModal = () => {
  addModal.value = false;
  clearFormAfterSend();
};

function clearFormAfterSend() {
  form.values.title = "";
  form.values.exchange = "";
  form.values.api_key = "";
  form.values.secret_key = "";
  form.$v.value.$reset();
}

const addLoading = ref(false);
function addExchange() {
  form.$v.value.$touch();
  if (!form.$v.value.$invalid) {
    addLoading.value = true;
    ApiService.post("/bot/exchange/add/", {
      user: user?.value?.id || 0,
      ...form.values,
    })
      .then(() => {
        trackCustomEvent("UserAddExchangeSuccess", {
          event_category: "form",
          event_label: "add_exchange_success",
          button_text: "Add Exchange",
        });
        showToast(t("success"), "success");
        getExchanges();
      })
      .finally(() => {
        addModal.value = false;
        addLoading.value = false;
      });
  }
}
const refreshBalance = () => {
  isRefreshed.value = true;
  ApiService.post(`/bot/exchange/refresh/${formBot.values.exchange}/`)
    .then((res) => {
      trackCustomEvent("UserRefreshBalance", {
        event_category: "exchange",
        event_label: "refresh_balance",
        button_text: "Refresh Balance",
      });
      formBot.values.exchange = res?.data?.id;
      exchanges.value = [res?.data];
    })
    .catch((err: any) => {
      console.log(err, "err");
    })
    .finally(() => {
      setTimeout(() => {
        isRefreshed.value = false;
      }, 300);
    });
};

function removeCoin(option: any) {
  const index = chosenCoins.value.findIndex((el: any) => el.id === option.id);
  chosenCoins.value.splice(index, 1);
}

function getCoins() {
  ApiService.query("/bot/common/coins", {
    params: {
      size: 100,
    },
  }).then((res) => {
    coins.value = res.data?.results;
  });
}

function getExchanges() {
  ApiService.get("/bot/exchange/").then((res) => {
    exchanges.value = res.data?.results;
  });
}

function getStrategies() {
  ApiService.get("/bot/common/strategy/").then((res) => {
    res.data?.results?.map((option) => {
      if (user.value?.plan?.allowed_strategies?.includes(option?.id)) {
        strategies.value.push(option);
      }
    });
  });
}

getCoins();
getExchanges();
getStrategies();

const acceptConfig = reactive({
  text: t("create"),
  disabled: formBot.$v.value.$invalid,
  loading: false,
  width: "w-[120px]",
});

function submit() {
  formBot.$v.value.$touch();
  if (!chosenCoins.value?.length) {
    coinError.value = true;
  }
  if (!formBot.$v.value.$invalid && chosenCoins.value?.length) {
    acceptConfig.loading = true;
    const data = {
      title: formBot.values.name,
      exchange: formBot.values.exchange,
      strategy: formBot.values.strategy,
      assigned_money: formBot.values.money.replace(/\s/g, ""),
      currency: "USDT",
      is_active: true,
      coins: chosenCoins.value.map((el: any) => el.id) || [],
      max_open_positions: max_open_position.value,
    };
    pushToDataLayer("create_bot_attempt", {
      event_category: "create_bot",
      event_label: "create_bot_attempt",
      button_text: "Create Bot",
    });
    trackCustomEvent("UserCreateBotAttempt", {
      event_category: "create_bot",
      event_label: "create_bot_attempt",
      button_text: "Create Bot",
    });
    ApiService.post("/bot/add/", data)
      .then(() => {
        router.push({ name: "Bots" });
        useAuthStore().fetchUserData();
        pushToDataLayer("create_bot_success", {
          event_category: "create_bot",
          event_label: "create_bot_success",
          button_text: "Create Bot",
        });
        trackCustomEvent("UserCreateBotSuccess", {
          event_category: "create_bot",
          event_label: "create_bot_success",
          button_text: "Create Bot",
        });
      })
      .finally(() => {
        acceptConfig.loading = false;
      });
  }
}

watch(
  () => chooseAll.value,
  () => {
    if (chooseAll.value) {
      chosenCoins.value = [];
      coins.value.forEach((el) => {
        if (user.value?.plan?.allowed_coins?.includes(el?.id)) {
          chosenCoins.value.push(el);
        }
      });
    } else {
      chosenCoins.value = [];
      coinError.value = false;
    }
  },
);

watch(
  () => formBot.values.money,
  (val) => {
    if (val) {
      formBot.$v.value.exchange?.$touch();
      formBot.$v.value.strategy?.$touch();
    }
  },
);

watch(
  () => formBot.values.money,
  (val) => {
    isCheck.value = false;
    isLowMoney.value = false;
    if (val?.length !== 0) {
      debounce("search", () => {
        const moneyValue = Number(val.replace(/\s/g, ""));
        // Note: BTC removed
        isCheck.value = moneyValue > available_usdt_Balance.value;
        isLowMoney.value = moneyValue < max_open_position.value * 15;

        acceptConfig.disabled =
          formBot.$v.value.$invalid || isCheck.value || isLowMoney.value;
      });
    }
  },
  { immediate: true, deep: true },
);
watch(
  () => formBot.values.name,
  (val) => {
    if (val?.length !== 0) {
      acceptConfig.disabled =
        formBot.$v.value.$invalid || isCheck.value || isLowMoney.value;
    }
  },
  { immediate: true, deep: true },
);
watch(
  () => isCheck.value,
  (val) => {
    if (val) {
      showToast(t("balance_enough_funds"), "error");
    }
  },
);
watch(
  () => isLowMoney.value,
  (val) => {
    if (val && formBot.values.money?.length) {
      showToast(
        t("min_funds", { money: max_open_position.value * 15 }),
        "error",
      );
    }
  },
);

watch(
  () => formBot.values.currency,
  (val) => {
    if (val) {
      formBot.values.money = "";
    }
  },
);

watch(
  () => formBot.values.exchange,
  (val) => {
    if (val) {
      formBot.values.money = "";
      isLowMoney.value = false;
    }
  },
);

watch(
  () => formBot.values.strategy,
  (val) => {
    if (val) {
      const strategyCoins = strategies.value.find(
        (el) => el?.id === val,
      )?.coins;
      const timeFrame = strategies.value.find(
        (el) => el?.id === val,
      )?.time_frame;
      if (timeFrame?.length) {
        formBot.values.hours = timeFrame;
      }
      const maxOpenPosition = strategies.value.find(
        (el) => el?.id === val,
      )?.max_open_positions;
      if (maxOpenPosition) {
        max_open_position.value = maxOpenPosition;
      }
      if (strategyCoins?.length) {
        isStrategyCoins.value = true;
        chosenCoins.value = [];
        coins.value.forEach((el) => {
          if (strategyCoins?.includes(el?.id)) {
            chosenCoins.value.push(el);
          }
        });
      } else {
        isStrategyCoins.value = false;
        chosenCoins.value = [];
      }
      available_usdt_Balance.value = Number(
        checkExchangeBalance.value[0]?.available_usdt_balance?.replace(
          /\s/g,
          "",
        ),
      );
      acceptConfig.disabled =
        formBot.$v.value.$invalid || isCheck.value || isLowMoney.value;
    }
  },
  { immediate: true, deep: true },
);
watch(
  () => chosenCoins.value,
  (val) => {
    if (!val?.length) {
      acceptConfig.disabled =
        formBot.$v.value.$invalid || isCheck.value || isLowMoney.value || true;
    } else {
      acceptConfig.disabled =
        formBot.$v.value.$invalid || isCheck.value || isLowMoney.value;
    }
  },
  { immediate: true, deep: true },
);
const handleInputFocus = () => {
  if (!formBot.values.exchange && !formBot.values.currency) {
    showToast(t("select_strategy_exchange_first"), "warning");
  }
};

const routes = computed(() => [
  {
    name: t("add"),
    route: "/bots/add",
  },
]);

const checkExchangeBalance = computed(() => {
  return exchanges.value?.filter(
    (item) => item?.id === formBot.values.exchange,
  );
});
onMounted(() => {
  pushToDataLayer("pageview", {
    page: "add_bot",
    event_category: "page",
    event_label: "add_bot_page_view",
    button_text: "None",
  });
});
</script>

<style>
.refresh {
  animation: spinIt 0.8s infinite linear !important;
}
@keyframes spinIt {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.from-right-enter-active {
  animation: from-right 300ms ease-out;
}

.from-right-leave-active {
  animation: from-right 300ms ease-in reverse;
}

@keyframes from-right {
  0% {
    opacity: 0;
    transform: translateX(20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.refreshed-animation {
  animation: refreshed 500ms ease-in reverse;
}
@keyframes refreshed {
  0% {
    color: #080a15;
  }
  50% {
    color: #16cc53;
  }
  100% {
    color: #080a15;
  }
}
</style>
